<template>
  <div class="modificationManagement-page">
    <div class="all-content-container">
      <div class="table-content-container">
        <div class="table-title-container">
          <h4>历史模型</h4>
          <div class="table-content-title">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="修改人：">
                <el-input v-model="input" placeholder="修改人"></el-input>
              </el-form-item>
              <el-form-item label="修改时间：" class="edit-time">
                <el-date-picker
                  v-model="value1"
                  type="monthrange"
                  range-separator="-"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button @click="onSubmit">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content">
          <div class="table-table">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="szzw" label="生长作物"></el-table-column>
              <el-table-column prop="xgq" label="修改前模型"></el-table-column>
              <el-table-column prop="xgh" label="修改后模型"></el-table-column>
              <el-table-column prop="xgr" label="修改人"></el-table-column>
              <el-table-column prop="xgsj" label="修改时间"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "modificationManagement",
  data() {
    return {
      tableData: [
        {
          szzw: "番茄",
          xgq: "番茄生长模型1",
          xgh: "番茄生长模型2",
          xgr: "admin",
          xgsj: "2019-12-06 23:12:10"
        },
        {
          szzw: "番茄",
          xgq: "番茄生长模型1",
          xgh: "番茄生长模型2",
          xgr: "admin",
          xgsj: "2019-12-06 23:12:10"
        },
        {
          szzw: "番茄",
          xgq: "番茄生长模型1",
          xgh: "番茄生长模型2",
          xgr: "admin",
          xgsj: "2019-12-06 23:12:10"
        }
      ],
      input: "",
      value1: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            }
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      value2: ""
    };
  },
  methods: {
    onSubmit() {},
    
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/modificationManagement.scss";
</style>